<div class="content" [ngClass]="{ 'not-device': lockScreenWithoutDevice }">
  <p class="title" *ngIf="!lockScreenWithoutDevice">Bem-vindo!</p>
  <p *ngIf="!lockScreenWithoutDevice">Por favor, aguarde.</p>
  <p *ngIf="!lockScreenWithoutDevice">A pesquisa estará disponível em breve.</p>

  <p class="title" *ngIf="lockScreenWithoutDevice">O totem foi desativado.</p>
  <p *ngIf="lockScreenWithoutDevice">
    Para suporte, entre em contato com o Help Desk.
  </p>
  <p *ngIf="lockScreenWithoutDevice">Telefone: (19) 3778-3720</p>

  <img src="assets/img/logo.png" alt="logotipo" width="200" />
</div>
